import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { Box, Container, Grid } from '@mui/material';
import TotalOrders from 'src/components/dashboard/TotalOrders';
import TotalCredits from 'src/components/dashboard/TotalCredits';
import OrderReportByStatus from 'src/components/dashboard/OrderReportByStatus';
import { getOrderSalesReport } from 'src/store/reports/reports.action';
import HelmetSeo from 'src/components/HelmetSeo';
import { fectchHelpers } from 'src/store/actions/general.action';
import UsersReport from 'src/components/dashboard/UsersReport';
import Budget from '../components/dashboard/Budget';
import OrderList from '../components/dashboard/OrderList';
import LatestProducts from '../components/dashboard/LatestProducts';
import TotalCustomers from '../components/dashboard/TotalCustomers';
import SalesReport from '../components/dashboard/SalesReport';
import { getCounts } from '../store/actions/users.action';
import { getLatestOrders, getOrderReportStatus } from '../store/orders/orders.action';

function Dashboard() {
  const dispatch = useDispatch();
  const orderState = useSelector((state) => state.orderReducer);
  const { orders } = orderState;

  useEffect(() => {
    dispatch(getCounts());
    dispatch(getOrderReportStatus());
    dispatch(getOrderSalesReport());
    dispatch(fectchHelpers());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getLatestOrders());
  }, [dispatch]);

  return (
    <>
      <HelmetSeo title="Home | Rewot Ciro" />
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
        }}
      >
        <Box>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              lg={3}
              sm={6}
              xl={3}
              xs={12}
            >
              <Budget />
            </Grid>

            <Grid
              item
              lg={3}
              sm={6}
              xl={3}
              xs={12}
            >
              <TotalCustomers />
            </Grid>
            <Grid
              item
              lg={3}
              sm={6}
              xl={3}
              xs={12}
            >
              <TotalOrders />
            </Grid>
            <Grid
              item
              lg={3}
              sm={6}
              xl={3}
              xs={12}
            >
              <TotalCredits />
            </Grid>

            <Grid
              item
              lg={8}
              sm={6}
              xl={8}
              xs={12}
            >
              <SalesReport />
            </Grid>

            <Grid
              item
              lg={4}
              md={6}
              xl={4}
              xs={12}
            >
              <OrderReportByStatus />
            </Grid>

            <Grid
              item
              lg={7}
              md={6}
              xl={7}
              xs={12}
            >
              <UsersReport />
            </Grid>

            <Grid
              item
              lg={5}
              md={6}
              xl={5}
              xs={12}
            >
              <LatestProducts sx={{ height: '100%' }} />
            </Grid>

            <Grid
              item
              lg={8}
              md={12}
              xl={9}
              xs={12}
            >
              <OrderList orders={orders} title="Latest orders" />
            </Grid>

            <Grid
              item
              lg={4}
              md={6}
              xl={3}
              xs={12}
            >
              {/* <LatestProducts sx={{ height: '100%' }} /> */}
            </Grid>
            <Grid
              item
              lg={8}
              md={12}
              xl={9}
              xs={12}
            >
              {/* <OrderList orders={orders.reverse()} title="Latest orders" /> */}
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
}

export default Dashboard;
